import { getApiBaseUrl } from '../utils/apiBaseUrl';

/**
 * GET /api/admin/dashboard — MongoDB aggregates (users, domains, projects).
 */
export async function fetchAdminDashboard(signal) {
  const base = getApiBaseUrl();
  const path = '/api/admin/dashboard';
  const url = base ? `${base}${path}` : path;
  const res = await fetch(url, {
    method: 'GET',
    signal,
    headers: { Accept: 'application/json' },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : `HTTP ${res.status}`);
  }
  if (!data.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : 'invalid_response');
  }
  return data;
}
